import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from 'material-ui/styles';
import {CircularProgress} from 'material-ui/Progress';

const styles = () => ({
	progress: {
		display: 'block',
		width: '128px!important',
		height: '128px!important',
		margin: 'auto'
	},
	absolute: {
		position: 'absolute',
		top: 'calc(50% - 64px)',
		left: 'calc(50% - 64px)'
	}
});

const Indicator = ({classes, absolutelyCentered}) => {
	const classNames = `${classes.progress} ${absolutelyCentered && classes.absolute}`;

	return (
		<CircularProgress className={classNames} size={50}/>
	);
};

Indicator.propTypes = {
	classes: PropTypes.object.isRequired,
	absolutelyCentered: PropTypes.bool
};

export default withStyles(styles)(Indicator);



// WEBPACK FOOTER //
// ./src/client/components/common/with-loading-indicator/indicator.jsx